import React, { FC, useState } from 'react';
import {
  useGetAdminCompetitionItemPrizePlaceQuery,
  // useGetAdminCompetitionItemPrizePlacesQuery,
  useGetAdminCompetitionItemQuery,
  useSendAwardMutation,
} from 'entities/competitions-b2b';
import { Typography } from '@mui/material';
import { Box } from '@mui/system';
import { LayerUITitle } from 'entities/prize';
import { DeliveryInfoFeature } from 'features/prize/deliveryInfo';
import { CircularLoader } from 'shared/ui/CircularLoader/CircularLoader';
import mark from 'shared/icons/mark-circle.svg';
import info from 'shared/icons/info.svg';
import { useParams } from 'react-router';
import { DialogConfirm } from 'shared/ui/DialogConfirm';
import { ShortPresentationItem } from '../ShortPresentationItem';
import { CompetitionSalesPointRatingStatsWidget } from '../salePoint';
import { ICompetitionsPrizePlaceWidget } from './types';

const CompetitionsPrizePlaceWidget: FC<ICompetitionsPrizePlaceWidget> = ({ awardPlaceId }) => {
  const { data: prizePlace } = useGetAdminCompetitionItemPrizePlaceQuery({ award_place_id: awardPlaceId });
  // const { data: prizePlaces } = useGetAdminCompetitionItemPrizePlacesQuery();
  const params = useParams();

  const id = parseInt(params.id || '');
  const ttId = parseInt(params.ttId || '');
  const { data: competitionData } = useGetAdminCompetitionItemQuery({ competition_id: id });
  const [showParcelDialog, setShowParcelDialog] = useState(false);
  const [sendAward] = useSendAwardMutation();

  const sendParcel = () => {
    if (!prizePlace) return;
    sendAward({ awardPlaceId: prizePlace.id });
    setShowParcelDialog(false);
  };

  if (!prizePlace) return <CircularLoader />;

  // const award = prizePlaces?.items.find((ppl) => ppl.id === prizePlace.id);
  const coinsFlow = prizePlace?.award_chosen?.coins;
  const salePoint = prizePlace.participant?.sales_point;

  return (
    <Box>
      <LayerUITitle>Данные призового места</LayerUITitle>
      <Box sx={{ display: 'flex', justifyContent: 'space-between', width: '55%', mb: 3 }}>
        <ShortPresentationItem
          title="Место"
          value={prizePlace.place.toString() || '---'}
        />
        {/* <ShortPresentationItem title='Рейтинг' value='82 000' /> */}
        <ShortPresentationItem
          title="Время выбора награды"
          value={prizePlace.time_award_selection || '---'}
        />
        <ShortPresentationItem
          title="Время получения награды"
          value={prizePlace.time_award_receiving || '---'}
        />
        <ShortPresentationItem
          underline
          title="Соревнование"
          value={prizePlace.competition?.name}
        />
        <ShortPresentationItem
          underline
          title="Участник"
          value={prizePlace.participant?.sales_point?.title || '---'}
        />
      </Box>

      <LayerUITitle>Владелец ТТ выбравший награду:</LayerUITitle>
      <Box sx={{ display: 'flex' }}>
        <Typography
          width={130}
          fontWeight="500"
        >
          Название ТТ:
        </Typography>
        <Typography
          color={salePoint?.title ? '#4782DA' : undefined}
          style={salePoint?.title ? { textDecoration: 'underline' } : undefined}
          fontWeight="400"
        >
          {salePoint?.title || '---'}
        </Typography>
      </Box>
      <Box
        sx={{ display: 'flex' }}
        mb={2}
      >
        <Typography
          width={130}
          fontWeight="500"
        >
          Номер:
        </Typography>
        <Typography fontWeight="400">{prizePlace.user?.phone || '---'}</Typography>
      </Box>

      {prizePlace?.award_chosen ? (
        <>
          <LayerUITitle>Выбранная награда:</LayerUITitle>
          <Box
            sx={{
              backgroundColor: '#E0F0EB',
              paddingLeft: 3.33,
              paddingRight: 3.33,
              paddingTop: 2,
              paddingBottom: 2,
              width: '50%',
              borderRadius: 3,
              marginBottom: 4,
            }}
          >
            <Box sx={{ display: 'flex', alignItems: 'center', mb: 0.33 }}>
              <img
                style={{ marginRight: 2 }}
                src={mark}
                alt=""
              />
              <Typography
                color="#28D19E"
                fontSize={14}
              >
                Выбранная награда
              </Typography>
            </Box>
            <Box sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
              <img
                style={{ marginRight: 2 }}
                src={info}
                alt=""
              />
              <Typography
                color="rgba(0, 0, 0, 0.50)"
                fontSize={14}
              >
                Основная награда
              </Typography>
            </Box>
            <Box
              sx={{ display: 'flex' }}
              mb={1}
            >
              <Typography
                width={130}
                fontWeight="500"
              >
                Тип:
              </Typography>
              <Typography fontWeight="400">{coinsFlow ? 'Монеты' : 'Товар'}</Typography>
            </Box>
            <Box
              sx={{ display: 'flex' }}
              mb={1}
            >
              <Typography
                width={130}
                fontWeight="500"
              >
                Название:
              </Typography>
              <Typography fontWeight="400">
                {coinsFlow
                  ? `${prizePlace?.award_chosen?.coins || 0} монет`
                  : prizePlace?.award_chosen?.prize.name || '---'}
              </Typography>
            </Box>
            {!coinsFlow ? (
              <>
                <Box
                  sx={{ display: 'flex' }}
                  mb={1}
                >
                  <Typography
                    width={130}
                    fontWeight="500"
                  >
                    Описание:
                  </Typography>
                  <Typography fontWeight="400">{prizePlace?.award_chosen?.prize.description || '---'}</Typography>
                </Box>
                <Box
                  sx={{ display: 'flex' }}
                  mb={1}
                >
                  <Typography
                    width={130}
                    fontWeight="500"
                  >
                    Ценность:
                  </Typography>
                  <Typography fontWeight="400">{prizePlace?.award_chosen?.prize.estimation || '---'}</Typography>
                </Box>
                <Box
                  sx={{ display: 'flex' }}
                  mb={1}
                >
                  <Typography
                    width={130}
                    fontWeight="500"
                  >
                    Изображение:
                  </Typography>
                  {prizePlace?.award_chosen?.prize.image_main ? (
                    <Box
                      width={64}
                      height={64}
                      sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}
                    >
                      <img
                        style={{ maxWidth: '100%', maxHeight: '100%' }}
                        src={prizePlace?.award_chosen?.prize.image_main}
                        alt=""
                      />
                    </Box>
                  ) : (
                    <Typography fontWeight="400">---</Typography>
                  )}
                </Box>
                {competitionData ? (
                  <CompetitionSalesPointRatingStatsWidget
                    participantId={ttId}
                    competitionId={id}
                    label="Статистика изменения места в рейтинге"
                  />
                ) : null}
              </>
            ) : null}
          </Box>
        </>
      ) : null}
      <DeliveryInfoFeature
        showParcelDialog={showParcelDialog}
        setShowParcelDialog={setShowParcelDialog}
        coinsFlow={!!coinsFlow}
        prizePlace={prizePlace}
      />
      {showParcelDialog ? (
        <DialogConfirm
          handleConfirm={sendParcel}
          title="Подтвердите действие"
          description="Вы уверены что хотите отправить награду?"
          handleClose={() => setShowParcelDialog(false)}
          open={showParcelDialog}
        />
      ) : null}
    </Box>
  );
};

export { CompetitionsPrizePlaceWidget };
